// extracted by mini-css-extract-plugin
module.exports = {"img":"ProxyVoteIcon_img__1AEk2"};